export const carListTypes = Object.freeze({
  SET_CAR_LIST: 'SET_CAR_LIST',
  UPDATE_CARS_FILTER: 'UPDATE_CARS_FILTER',
  UPDATE_PRICE_FILTER: 'UPDATE_PRICE_FILTER',
  REMOVE_CARS_FILTER: 'REMOVE_CARS_FILTER',
  SORT_CARS: 'SORT_CARS',
  SET_QUANTITY_CARS: 'SET_QUANTITY_CARS'
})
